export const formatCharacterCount = (maxLength: number, value: string) => {
    if (maxLength) {
        return `${value?.length ?? 0} / ${maxLength}`;
    }
    return null;
};
